
window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

// Módulo de Máquinas - Agora conectado ao Supabase
window.FazendaRP.Pages.maquinas = {
    // Armazena dados e ESTADO DA TELA
    data: {
        frota: [],
        manutencoes: [],
        abastecimentos: [] // Ainda local por enquanto
    },

    // Estado do filtro atual (padrão: mostrar tudo)
    currentFilter: 'todos',

    // Função Helper para Estilo Visual (Gradientes Premium)
    getStyleForType: function (tipo) {
        // Normaliza para uppercase para evitar problemas de capitalização
        const tipoNorm = (tipo || '').toUpperCase();

        switch (tipoNorm) {
            case 'TRATOR':
                return { bg: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)', icon: 'fa-tractor' }; // Vege Green
            case 'CAMINHAO':
            case 'CAMINHÃO':
                return { bg: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)', icon: 'fa-truck' }; // Royal Blue
            case 'CAMIONETE':
            case 'CAMINHONETE':
                return { bg: 'linear-gradient(135deg, #4b5563 0%, #1f2937 100%)', icon: 'fa-truck-pickup' }; // Slate Gray
            case 'CARRO':
                return { bg: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)', icon: 'fa-car' }; // Sky Blue
            case 'COLHEITADEIRA':
            case 'COLHEDEIRA':
                return { bg: 'linear-gradient(135deg, #eab308 0%, #ca8a04 100%)', icon: 'fa-industry' }; // Golden Yellow
            case 'IMPLEMENTO':
                return { bg: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)', icon: 'fa-tools' }; // Purple
            default:
                return { bg: 'linear-gradient(135deg, #64748b 0%, #475569 100%)', icon: 'fa-cogs' }; // Gray
        }
    },

    // Função principal de renderização da tela
    render: function (container) {
        container.innerHTML = `
            <div id="maquinas-module">
                
                <!-- Submenu Interno (Barra de Ferramentas) -->
                <div class="submenu-container" style="flex-wrap: wrap;">
                    <div class="submenu-item active" data-tab="dashboard"><i class="fas fa-chart-line"></i> Visão Geral</div>
                    <div class="submenu-item" data-tab="frota"><i class="fas fa-tractor"></i> Frota</div>
                    <div class="submenu-item" data-tab="manutencoes"><i class="fas fa-history"></i> Histórico de Manutenções</div>
                    <div class="submenu-item" data-tab="abastecimentos"><i class="fas fa-gas-pump"></i> Abastecimentos</div>
                </div>

                <!-- Header com Botão AO LADO do Título -->
                <div style="display: flex; align-items: center; gap: 20px; margin-bottom: 20px;">
                    <div>
                        <h2 id="maquinas-page-title" style="margin-bottom: 5px;">Dashboard da Frota</h2> 
                        <p style="color: var(--text-muted); margin: 0; font-size: 0.9rem;">Visão geral de custos e atividades.</p>
                    </div>
                    <!-- Botão de Ação -->
                    <div id="page-actions">
                        <button id="btn-nova-maquina" class="btn btn-primary" style="padding: 5px 15px; font-size: 0.9rem; display:none;"><i class="fas fa-plus"></i> Nova Máquina</button>
                    </div>
                </div>

                <!-- Área de Conteúdo -->
                <div id="maquinas-content">
                    <div style="text-align: center; padding: 40px;"><i class="fas fa-spinner fa-spin"></i> Carregando...</div>
                </div>
            </div>
        `;

        // Carrega os dados do Supabase
        this.loadData();

        // Configura as Abas
        const tabs = container.querySelectorAll('.submenu-item[data-tab]');
        const btnNovaMaquina = document.getElementById('btn-nova-maquina');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const currentActive = container.querySelector('.submenu-item.active');
                if (currentActive) currentActive.classList.remove('active');
                tab.classList.add('active');

                const titleEl = document.getElementById('maquinas-page-title');
                const subtitleEl = titleEl.nextElementSibling;
                const tabName = tab.dataset.tab;

                // Logica de troca de abas e visibilidade do botão
                if (tabName === 'dashboard') {
                    if (titleEl) titleEl.innerText = "Dashboard da Frota";
                    if (subtitleEl) subtitleEl.innerText = "Visão geral de custos e atividades.";
                    if (btnNovaMaquina) btnNovaMaquina.style.display = 'none';
                    this.renderDashboard();
                } else if (tabName === 'frota') {
                    if (titleEl) titleEl.innerText = "Gestão de Frota";
                    if (subtitleEl) subtitleEl.innerText = "Controle de máquinas e veículos.";
                    if (btnNovaMaquina) btnNovaMaquina.style.display = 'inline-flex'; // Mostra botão
                    this.renderFrota();
                } else if (tabName === 'manutencoes') {
                    if (titleEl) titleEl.innerText = "Histórico de Peças e Manutenções";
                    if (subtitleEl) subtitleEl.innerText = "Registro completo de serviços.";
                    if (btnNovaMaquina) btnNovaMaquina.style.display = 'none'; // Esconde botão
                    this.renderManutencoes();
                } else if (tabName === 'abastecimentos') {
                    if (titleEl) titleEl.innerText = "Registro de Abastecimentos";
                    if (subtitleEl) subtitleEl.innerText = "Histórico de consumo de combustível.";
                    if (btnNovaMaquina) btnNovaMaquina.style.display = 'none'; // Esconde botão
                    this.renderAbastecimentos();
                }
            });
        });

        // Configura o modal inicial
        this.setupModalNovaMaquina();

        // Atrela evento ao botão fixo do header (Modo Criação)
        if (btnNovaMaquina) {
            btnNovaMaquina.onclick = () => {
                this.openModalMaquina(null);
            };
        }
    },

    // Carrega dados do Banco de Dados (Supabase)
    loadData: async function () {
        console.log("Iniciando carregamento do Supabase...");

        // Verifica se o cliente Supabase existe
        const supabase = window.FazendaRP.supabase;
        if (!supabase) {
            alert("Erro: Supabase não conectado.");
            return;
        }

        try {
            // 1. Busca a frota da tabela 'frota'
            const { data: frota, error: errFrota } = await supabase
                .from('frota')
                .select('*');

            if (errFrota) throw errFrota;

            // Atualiza a memória local com os dados vindos da nuvem
            this.data.frota = frota || [];
            console.log("Frota carregada:", this.data.frota);

            // 2. Busca Abastecimentos do Supabase (com Join para num_doc)
            const { data: abastecimentos, error: errAbs } = await supabase
                .from('maquinas_abastecimentos')
                .select('*, financeiro_lancamentos(num_doc)')
                .order('data', { ascending: false });

            if (errAbs) throw errAbs;

            // Store RAW snake_case data because renderAbastecimentos expects it.
            this.data.abastecimentos = abastecimentos || [];
            console.log("Abastecimentos carregados (RAW):", this.data.abastecimentos.length);


            // 3. Força carregamento de manutenções para o Dashboard
            await this.ensureManutencoesLoaded();

            // Atualiza a tela com os dados carregados (Dashboard por padrão)
            this.renderDashboard();

        } catch (e) {
            console.error("Erro ao carregar dados:", e);
            const content = document.getElementById('maquinas-content');
            if (content) content.innerHTML = `<p style="color:red">Erro ao carregar dados: ${e.message}</p>`;
        }
    },

    // Renderiza a grade de tratores
    renderFrota: function () {
        const container = document.getElementById('maquinas-content');
        if (!container) return;

        // FILTRO DOS DADOS (Memória Local)
        let listaExibicao = this.data.frota;
        if (this.currentFilter !== 'todos') {
            listaExibicao = this.data.frota.filter(m => (m.status || 'ativo') === this.currentFilter);
        }

        // Barra de Ação (Apenas Filtros agora, sem botão)
        const actionBar = document.createElement('div');
        actionBar.className = 'action-bar';
        actionBar.style.marginBottom = '20px';
        actionBar.style.display = 'flex';
        actionBar.style.gap = '15px';
        actionBar.style.justifyContent = 'flex-start';

        // Helper para estilo do botão de filtro
        const getFilterStyle = (filterName, colorFn) => {
            const isSelected = this.currentFilter === filterName;
            const baseStyle = "cursor: pointer; transition: all 0.2s; user-select: none;";
            if (isSelected) {
                return baseStyle + `opacity: 1; transform: scale(1.05); box-shadow: 0 2px 5px rgba(0,0,0,0.15); border: 2px solid currentColor; padding: 2px 8px;`;
            }
            return baseStyle + "opacity: 0.5; border: 2px solid transparent; padding: 2px 8px;";
        };

        // Filtros Clicáveis
        actionBar.innerHTML = `
            <div class="filter-group" style="display: flex; align-items: center; gap: 8px;">
                <span style="font-size: 0.9rem; color: #666; margin-right: 5px;"><b>Situação:</b></span>
                
                <span class="badge badge-filter" data-filter="todos" 
                      style="background:#e5e7eb; color:#374151; ${getFilterStyle('todos')}">
                      Todos
                </span>

                <span class="badge badge-filter" data-filter="ativo" 
                      style="background:#d1fae5; color:#065f46; ${getFilterStyle('ativo')}">
                      Ativo
                </span>

                <span class="badge badge-filter" data-filter="inativo" 
                      style="background:#fee2e2; color:#b91c1c; ${getFilterStyle('inativo')}">
                      Inativo
                </span>

                <span class="badge badge-filter" data-filter="vendido" 
                      style="background:#f3f4f6; color:#1f2937; border: 1px solid #ccc; ${getFilterStyle('vendido')}">
                      Vendido
                </span>
            </div>
        `;

        // Event Listeners dos Filtros
        actionBar.querySelectorAll('.badge-filter').forEach(badge => {
            badge.onclick = () => {
                this.currentFilter = badge.dataset.filter;
                this.renderFrota(); // Re-renderiza com o novo filtro
            };
        });

        // Container da Grade
        const gridContainer = document.createElement('div');

        if (listaExibicao.length === 0) {
            gridContainer.innerHTML = `
                <div style="text-align: center; padding: 40px; color: #666; background: #f8f9fa; border-radius: 8px;">
                    <i class="fas fa-search fa-3x" style="margin-bottom: 20px; color: #d1d5db;"></i>
                    <p>Nenhuma máquina encontrada com este filtro.</p>
                </div>
            `;
        } else {
            const grid = document.createElement('div');
            grid.style.display = 'grid';
            grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(280px, 1fr))';
            grid.style.gap = '25px';

            listaExibicao.forEach(maquina => {
                const card = document.createElement('div');
                card.className = 'card-maquina';
                // Estilo "Premium" para o Card
                card.style.background = '#ffffff';
                card.style.borderRadius = '12px';
                card.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
                card.style.overflow = 'hidden';
                card.style.transition = 'transform 0.2s';

                // Opacidade reduzida se não for ativo
                if (maquina.status && maquina.status !== 'ativo') {
                    card.style.opacity = '0.85'; // Um pouco menos transparente pra poder ler
                    // card.style.filter = 'grayscale(0.6)'; // Opcional
                }

                card.onmouseover = () => card.style.transform = 'translateY(-3px)';
                card.onmouseout = () => card.style.transform = 'translateY(0)';

                const estilo = this.getStyleForType(maquina.tipo);

                // Formatação (Fallback visuais)
                const labelModelo = maquina.modelo ? maquina.modelo : '-';
                const labelAno = maquina.ano ? maquina.ano : '-';

                // Formatação Visual do Tipo (Capitalize + Correção Ortográfica)
                let tipoVisual = maquina.tipo;
                if (tipoVisual === 'CAMIONETE') tipoVisual = 'Caminhonete';
                else if (tipoVisual === 'CAMINHAO') tipoVisual = 'Caminhão';
                else {
                    // Capitalize (Primeira maiúscula, resto minúscula)
                    tipoVisual = tipoVisual.charAt(0).toUpperCase() + tipoVisual.slice(1).toLowerCase();
                }

                // Badge de Status
                let statusBadge = '';
                if (maquina.status === 'vendido') {
                    statusBadge = `<span class="badge" style="background: #e5e7eb; color: #374151; font-size: 0.75rem; margin-left: 5px;">VENDIDO</span>`;
                } else if (maquina.status === 'inativo') {
                    statusBadge = `<span class="badge" style="background: #fee2e2; color: #991b1b; font-size: 0.75rem; margin-left: 5px;">INATIVO</span>`;
                }

                // Lógica de medidor para card (já ajustada anteriormente)
                let labelMedidor = '0';
                let unidadeMedidor = '';

                if (maquina.tipo === 'IMPLEMENTO') {
                    labelMedidor = '-';
                    unidadeMedidor = '';
                } else if (maquina.tipo.includes('CAMIN') || maquina.tipo === 'CAMIONETE' || maquina.tipo === 'CARRO') {
                    labelMedidor = (maquina.km_atual || 0).toLocaleString('pt-BR');
                    unidadeMedidor = 'KM';
                } else {
                    labelMedidor = (maquina.horimetro_atual || 0).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
                    unidadeMedidor = 'HR';
                }

                card.innerHTML = `
                    <div style="height: 160px; display: flex; align-items: center; justify-content: center; background: ${estilo.bg}; color: white; position: relative;">
                         <i class="fas ${estilo.icon} fa-5x" style="opacity: 0.9; text-shadow: 0 2px 10px rgba(0,0,0,0.2);"></i>
                         <!-- Status Overlay se vendido/inativo -->
                         ${maquina.status === 'vendido' ? '<div style="position: absolute; background: rgba(0,0,0,0.6); color: white; padding: 5px 15px; border-radius: 20px; font-weight: bold;">VENDIDO</div>' : ''}
                    </div>
                    
                    <div style="padding: 20px;">
                        <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 12px; flex-wrap: wrap; gap: 5px;">
                            <h3 style="margin: 0; color: #111827; font-size: 1.1rem; font-weight: 600;">${maquina.nome}</h3>
                            <div style="text-align: right;">
                                <span class="badge" style="background: #f3f4f6; color: #374151; font-size: 0.75rem;">${tipoVisual}</span>
                                ${statusBadge}
                            </div>
                        </div>
                        
                        <div style="color: #6b7280; font-size: 0.9rem; margin-bottom: 15px;">
                            <div style="margin-bottom: 6px; display:flex; align-items:center; gap:8px;" title="Modelo">
                                <i class="fas fa-barcode" style="width: 20px; text-align:center;"></i> 
                                <span>${labelModelo}</span>
                            </div>
                            <div style="margin-bottom: 6px; display:flex; align-items:center; gap:8px;" title="Ano de Fabricação">
                                <i class="fas fa-calendar" style="width: 20px; text-align:center;"></i> 
                                <span>${labelAno}</span>
                            </div>
                            <div style="display:flex; align-items:center; gap:8px;" title="Medidor Atual">
                                <i class="fas fa-tachometer-alt" style="width: 20px; text-align:center;"></i> 
                                <strong>${labelMedidor}</strong> 
                                <span style="font-size:0.8rem">${unidadeMedidor}</span>
                            </div>
                        </div>

                        <div style="border-top: 1px solid #f3f4f6; padding-top: 15px; display: flex; justify-content: flex-end; align-items: center;">
                             <button class="btn-detalhes-maq" data-id="${maquina.id}" style="border: none; background: transparent; color: var(--primary-color); cursor: pointer; font-weight: 600;">Detalhes <i class="fas fa-arrow-right"></i></button>
                        </div>
                    </div>
                `;

                // Conecta o evento do botão detalhes
                const btnDet = card.querySelector('.btn-detalhes-maq');
                btnDet.onclick = () => {
                    this.openModalMaquina(maquina);
                };

                grid.appendChild(card);
            });
            gridContainer.appendChild(grid);
        }

        container.innerHTML = '';
        container.appendChild(actionBar);
        container.appendChild(gridContainer);
    },

    // Variável para cache de manutenções
    cachedManutencoes: null,

    /* LEGACY/DEAD CODE - SEE V3.0 BELOW
    renderManutencoes_LEGACY_DEAD_CODE: async function () {
        console.log("Rendering Manutencoes v2 - With Filters"); // Debug Log
        const container = document.getElementById('maquinas-content');
        if (!container) return;

        // Se NAO tiver cache, mostra loading e busca. Se tiver, usa o que tem.
        if (!this.cachedManutencoes) {
            container.innerHTML = `
                <div style="text-align: center; padding: 40px;">
                    <i class="fas fa-spinner fa-spin fa-2x" style="color:var(--color-primary);"></i><br><br>
                    Buscando histórico financeiro...
                </div>
            `;

            try {
                // Fetch Financeiro
                const { data: lancamentos, error } = await window.FazendaRP.supabase
                    .from('financeiro_lancamentos')
                    .select(`
                        *,
                        parceiros (nome)
                    `)
                    .eq('tipo', 'Despesa')
                    .neq('status', 'Cancelado')
                    .order('data_emissao', { ascending: false })
                    .limit(1000);

                if (error) throw error;

                // Flatten Data
                const manutencoes = [];
                lancamentos.forEach(l => {
                    if (l.detalhes && l.detalhes.itens && Array.isArray(l.detalhes.itens)) {
                        l.detalhes.itens.forEach(item => {
                            if (item.maquina_id) {
                                const maq = this.data.frota.find(m => m.id == item.maquina_id);
                                console.log('DEBUG Maintenance Date (ALL):', l.id, 'Emissao:', l.data_emissao);
                                const fecha = l.data_emissao || (l.detalhes && l.detalhes.data_emissao) || l.data_vencimento;
                                manutencoes.push({
                                    id: l.id,
                                    data: fecha,
                                    maquinaId: item.maquina_id,
                                    maquinaNome: maq ? maq.nome : 'Desconhecida',
                                    peca: item.nome,
                                    qtd: item.qtd,
                                    valor_item: item.total,
                                    fornecedor: l.parceiros ? l.parceiros.nome : '-',
                                    categoria: item.categoria || l.detalhes.categoria || 'Geral'
                                });
                            }
                        });
                    }
                });

                this.cachedManutencoes = manutencoes;

            } catch (err) {
                console.error(err);
                container.innerHTML = `<p style="color:red">Erro ao carregar histórico: ${err.message}</p>`;
                return;
            }
        }

        // --- RENDERIZAR ESTRUTURA DE FILTROS NA TELA ---
        const maquinasOptions = this.data.frota.map(m => `<option value="${m.id}">${m.nome}</option>`).join('');

        const filtrosHTML = `
            <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: flex-end; background: #fff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 5px rgba(0,0,0,0.05); margin-bottom: 25px;">
                <div class="form-group" style="flex: 2; min-width: 200px;">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #555;">Filtrar por Máquina</label>
                    <select id="filtro-manut-maq" class="form-control" style="width: 100%;">
                    <select id="filtro-manut-maq" class="form-control" style="width: 100%;">
                        <option value="">Todas as Máquinas</option>
                        ${maquinasOptions}
                    </select>
                </div>
                <div class="form-group" style="flex: 1; min-width: 130px;">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #555;">De (Data)</label>
                    <input type="date" id="filtro-manut-ini" class="form-control" style="width: 100%;">
                </div>
                <div class="form-group" style="flex: 1; min-width: 130px;">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #555;">Até (Data)</label>
                    <input type="date" id="filtro-manut-fim" class="form-control" style="width: 100%;">
                </div>
                
                <!-- CARD TOTALIZADOR -->
                <div style="flex: 1; min-width: 200px; text-align: right; background: #fef2f2; padding: 10px 15px; border-radius: 8px; border: 1px solid #fee2e2;">
                    <span style="display: block; font-size: 0.85rem; color: #991b1b; margin-bottom: 2px;">Total Gasto (Seleção)</span>
                    <strong id="total-manut-display" style="font-size: 1.4rem; color: #dc2626;">R$ 0,00</strong>
                </div>
            </div>

            <div id="tabela-manutencao-area"></div>
        `;

        container.innerHTML = filtrosHTML;

        // Elementos DOM
        const selMaq = document.getElementById('filtro-manut-maq');
        const inpIni = document.getElementById('filtro-manut-ini');
        const inpFim = document.getElementById('filtro-manut-fim');
        const totalDisplay = document.getElementById('total-manut-display');
        const tabelaArea = document.getElementById('tabela-manutencao-area');

        // Função interna de filtragem e renderização da tabela
        const applyFilters = () => {
            let filtered = this.cachedManutencoes || [];

            // Filtro Máquina
            const maqId = selMaq.value;
            if (maqId) {
                filtered = filtered.filter(m => m.maquinaId == maqId);
            }

            // Filtro Data
            const dIni = inpIni.value;
            const dFim = inpFim.value;
            if (dIni) filtered = filtered.filter(m => m.data >= dIni);
            if (dFim) filtered = filtered.filter(m => m.data <= dFim);

            // Calcular Total
            const total = filtered.reduce((acc, curr) => acc + (curr.valor_item || 0), 0);
            totalDisplay.innerText = total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            // Renderizar Tabela
            if (filtered.length === 0) {
                tabelaArea.innerHTML = `
                    <div style="text-align: center; padding: 40px; color: #999; border: 2px dashed #eee; border-radius: 8px; background: #f9fafb;">
                        Nenhum registro encontrado para este filtro.
                    </div>
                `;
                return;
            }

            let html = `
                <div class="data-table-container">
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Máquina</th>
                            <th>Item / Serviço</th>
                            <th>Categoria</th>
                            <th>Fornecedor</th>
                            <th>Valor (R$)</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            filtered.forEach(m => {
                html += `
                    <tr>
                        <td>${m.data.split('-').reverse().join('/')}</td>
                        <td><strong style="color:var(--color-primary);">${m.maquinaNome}</strong></td>
                        <td>${m.qtd}x ${m.peca}</td>
                        <td><span class="badge" style="background:#f3f4f6; color:#555;">${m.categoria}</span></td>
                        <td>${m.fornecedor}</td>
                        <td style="font-weight:600; color:#dc2626;">${m.valor_item.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    </tr>
                 `;
            });

            html += `</tbody></table></div>`;
            tabelaArea.innerHTML = html;
        };

        // Listeners
        selMaq.addEventListener('change', applyFilters);
        inpIni.addEventListener('change', applyFilters);
        inpFim.addEventListener('change', applyFilters);

        // Inicializar
        applyFilters();
    },
    */

    // Função centralizada para abrir o modal (Criação ou Edição)
    openModalMaquina: function (maquina) {
        const modal = document.getElementById('modal-nova-maquina');
        const form = document.getElementById('form-nova-maquina');
        const titulo = document.getElementById('titulo-modal-maq');

        if (!modal || !form) return;

        form.reset();

        // Garante que existe o input hidden para ID
        let idInput = document.getElementById('maq-id-hidden');
        if (!idInput) {
            idInput = document.createElement('input');
            idInput.type = 'hidden';
            idInput.id = 'maq-id-hidden';
            form.appendChild(idInput);
        }
        idInput.value = ''; // Limpa ID

        // Função interna para formatar moeda na abertura
        const formatBRL = (val) => {
            if (!val) return '';
            return val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        };

        if (maquina) {
            // MODO EDIÇÃO
            if (titulo) titulo.innerText = "Editar Máquina / Veículo";
            idInput.value = maquina.id;

            document.getElementById('maq-nome').value = maquina.nome;
            document.getElementById('maq-tipo').value = maquina.tipo;

            // Set STATUS
            const statusEl = document.getElementById('maq-status');
            if (statusEl) statusEl.value = maquina.status || 'ativo';

            document.getElementById('maq-modelo').value = maquina.modelo;
            document.getElementById('maq-ano').value = maquina.ano;
            document.getElementById('maq-placa').value = maquina.placa;

            if (maquina.data_aquisicao) {
                document.getElementById('maq-ano-aq').value = maquina.data_aquisicao.split('-')[0];
            }

            document.getElementById('maq-valor').value = formatBRL(maquina.valor_aquisicao);
            document.getElementById('maq-medidor').value = maquina.horimetro_atual || maquina.km_atual || 0;

            // POPULATE COMBUSTIVEIS
            const checks = document.querySelectorAll('#maq-combustiveis-container input[type="checkbox"]');
            checks.forEach(c => c.checked = false); // Reset existing

            if (maquina.combustiveis && Array.isArray(maquina.combustiveis)) {
                maquina.combustiveis.forEach(fuel => {
                    const chk = document.querySelector(`#maq-combustiveis-container input[value="${fuel}"]`);
                    if (chk) chk.checked = true;
                });
            }

        } else {
            // MODO CRIAÇÃO
            if (titulo) titulo.innerText = "Nova Máquina / Veículo";
            document.getElementById('maq-ano-aq').value = new Date().getFullYear();
            document.getElementById('maq-valor').value = '';

            // Default Status Ativo
            const statusEl = document.getElementById('maq-status');
            if (statusEl) statusEl.value = 'ativo';
        }

        // --- LÓGICA DO BOTÃO EXCLUIR ---
        const btnDelete = document.getElementById('btn-delete-maq');
        if (btnDelete) {
            if (maquina) {
                // Modo Edição: Botão Visível
                btnDelete.style.display = 'block';

                // Remove listeners antigos para evitar duplicação (clone hack)
                const newBtn = btnDelete.cloneNode(true);
                btnDelete.parentNode.replaceChild(newBtn, btnDelete);

                // RESET STATE
                newBtn.innerText = "Excluir Máquina";
                newBtn.disabled = false;

                newBtn.addEventListener('click', async () => {
                    // 1. Verificação de Integridade (Regra de Ouro do Usuário)
                    // "Só pode excluir se não tiver lançado nada nela. Nem diesel e nenhuma peça, nem manutenção"

                    const id = maquina.id; // Supabase ID is int/bigint usually, but let's match loose

                    // Check Abastecimentos (Diesel)
                    const hasDiesel = this.data.abastecimentos.some(a => a.maquinaId == id);
                    if (hasDiesel) {
                        alert("⛔ NÃO É POSSÍVEL EXCLUIR!\n\nEsta máquina possui registros de ABASTECIMENTO (Diesel).\n\nPara manter o histórico financeiro, você deve apenas INATIVAR a máquina (mude a Situação para 'Inativo' ou 'Vendido').");
                        return;
                    }

                    // Check Manutenções (Peças/Serviços)
                    const hasManutencao = this.data.manutencoes && this.data.manutencoes.some(m => m.maquinaId == id);
                    if (hasManutencao) {
                        alert("⛔ NÃO É POSSÍVEL EXCLUIR!\n\nEsta máquina possui registros de MANUTENÇÃO (Peças/Serviços).\n\nPara manter o histórico, inative a máquina.");
                        return;
                    }

                    // 2. Confirmação Final
                    if (confirm(`Tem certeza que deseja excluir permanentemente "${maquina.nome}"?\n\nEssa ação não pode ser desfeita.`)) {
                        newBtn.innerText = "Excluindo...";
                        newBtn.disabled = true;

                        try {
                            const { error } = await window.FazendaRP.supabase
                                .from('frota')
                                .delete()
                                .eq('id', id);

                            if (error) throw error;

                            // Sucesso
                            alert("Máquina excluída com sucesso.");
                            this.loadData(); // Recarrega tudo
                            modal.style.display = 'none';

                        } catch (err) {
                            console.error(err);
                            alert("Erro ao excluir: " + err.message);
                            newBtn.innerText = "Excluir Máquina";
                            newBtn.disabled = false;
                        }
                    }
                });

            } else {
                // Modo Criação: Botão Oculto
                btnDelete.style.display = 'none';
            }
        }

        // Disparar evento change para ajustar UI do medidor
        document.getElementById('maq-tipo').dispatchEvent(new Event('change'));

        modal.style.display = 'flex';
    },

    // Variável para cache de manutenções
    cachedManutencoes: null,

    renderManutencoes: async function () {
        console.log("Rendering Manutencoes v3.0 - NEW FILE ACTIVE"); // Proof of life
        const container = document.getElementById('maquinas-content');
        if (!container) return;

        // Se NAO tiver cache, mostra loading e busca.
        // Se NAO tiver cache, mostra loading e busca.
        // FORCE RELOAD: Always fetch to ensure updates from Financeiro are reflected
        // if (!this.cachedManutencoes) {
        if (true) {
            container.innerHTML = `
                <div style="text-align: center; padding: 40px;">
                    <i class="fas fa-spinner fa-spin fa-2x" style="color:var(--color-primary);"></i><br><br>
                    Buscando histórico financeiro...
                </div>
            `;

            try {
                // Fetch Financeiro
                const { data: lancamentos, error } = await window.FazendaRP.supabase
                    .from('financeiro_lancamentos')
                    .select(`
                        *,
                        parceiros (nome)
                    `)
                    .eq('tipo', 'Despesa')
                    .neq('status', 'Cancelado')
                    .order('data_emissao', { ascending: false })
                    .limit(1000);

                if (error) throw error;

                // Flatten Data
                const manutencoes = [];
                lancamentos.forEach(l => {
                    // Helper to check if it's fuel
                    const isFuel = (str) => {
                        if (!str) return false;
                        const s = str.toLowerCase();
                        return s.includes('combust') || s.includes('diesel') || s.includes('gasolina') || s.includes('etanol');
                    };

                    // 1. Check for Itemized Maintenance
                    if (l.detalhes && l.detalhes.itens && Array.isArray(l.detalhes.itens)) {
                        l.detalhes.itens.forEach(item => {
                            if (item.maquina_id) {
                                const cat = item.categoria || l.detalhes.categoria || 'Geral';
                                // Skip Fuel
                                if (isFuel(cat) || isFuel(item.nome)) return;

                                const maq = this.data.frota.find(m => m.id == item.maquina_id);
                                manutencoes.push({
                                    id: l.id,
                                    data: l.data_emissao || (l.detalhes && l.detalhes.data_emissao) || l.data_vencimento,
                                    maquinaId: item.maquina_id,
                                    maquinaNome: maq ? maq.nome : 'Desconhecida',
                                    peca: item.nome,
                                    qtd: item.qtd,
                                    valor_item: item.total,
                                    fornecedor: l.parceiros ? l.parceiros.nome : '-',
                                    categoria: cat
                                });
                            }
                        });
                    }

                    // 2. Check for Simple Allocation (Rateio Maquinas)
                    if (l.detalhes && l.detalhes.custo_maquinas && Array.isArray(l.detalhes.custo_maquinas)) {
                        l.detalhes.custo_maquinas.forEach(c => {
                            const cat = l.detalhes.categoria || l.categoria || 'Geral';
                            // Skip Fuel
                            if (isFuel(cat) || isFuel(l.descricao)) return;

                            const maq = this.data.frota.find(m => m.id == c.maquina_id);
                            manutencoes.push({
                                id: l.id,
                                data: l.data_emissao || (l.detalhes && l.detalhes.data_emissao) || l.data_vencimento,
                                maquinaId: c.maquina_id,
                                maquinaNome: maq ? maq.nome : 'Desconhecida',
                                peca: (l.descricao || 'Despesa Geral'),
                                qtd: 1,
                                valor_item: c.valor,
                                fornecedor: l.parceiros ? l.parceiros.nome : '-',
                                categoria: cat,
                                simpleEntry: true
                            });
                        });
                    }
                });

                this.cachedManutencoes = manutencoes;

            } catch (err) {
                console.error(err);
                container.innerHTML = `<p style="color:red">Erro ao carregar histórico: ${err.message}</p>`;
                return;
            }
        }

        // --- RENDERIZAR ESTRUTURA DE FILTROS NA TELA ---
        const maquinasOptions = this.data.frota.map(m => `<option value="${m.id}">${m.nome}</option>`).join('');

        const filtrosHTML = `
            <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: flex-end; background: #fff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 5px rgba(0,0,0,0.05); margin-bottom: 25px;">
                <div class="form-group" style="flex: 2; min-width: 200px;">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #555;">Filtrar por Máquina</label>
                    <select id="filtro-manut-maq" class="form-control" style="width: 100%;">
                        <option value="">Todas as Máquinas</option>
                        ${maquinasOptions}
                    </select>
                </div>
                <div class="form-group" style="flex: 1; min-width: 130px;">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #555;">De (Data)</label>
                    <input type="date" id="filtro-manut-ini" class="form-control" style="width: 100%;">
                </div>
                <div class="form-group" style="flex: 1; min-width: 130px;">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #555;">Até (Data)</label>
                    <input type="date" id="filtro-manut-fim" class="form-control" style="width: 100%;">
                </div>
                
                <!-- CARD TOTALIZADOR -->
                <div style="flex: 1; min-width: 200px; text-align: right; background: #fef2f2; padding: 10px 15px; border-radius: 8px; border: 1px solid #fee2e2;">
                    <span style="display: block; font-size: 0.85rem; color: #991b1b; margin-bottom: 2px;">Total Gasto (Seleção)</span>
                    <strong id="total-manut-display" style="font-size: 1.4rem; color: #dc2626;">R$ 0,00</strong>
                </div>
            </div>

            <div id="tabela-manutencao-area"></div>
        `;

        container.innerHTML = filtrosHTML;

        // Elementos DOM
        const selMaq = document.getElementById('filtro-manut-maq');
        const inpIni = document.getElementById('filtro-manut-ini');
        const inpFim = document.getElementById('filtro-manut-fim');
        const totalDisplay = document.getElementById('total-manut-display');
        const tabelaArea = document.getElementById('tabela-manutencao-area');

        // Função interna de filtragem e renderização da tabela
        const applyFilters = () => {
            let filtered = this.cachedManutencoes || [];

            // Filtro Máquina
            const maqId = selMaq.value;
            if (maqId) filtered = filtered.filter(m => m.maquinaId == maqId);

            // Filtro Data
            const dIni = inpIni.value;
            const dFim = inpFim.value;
            if (dIni) filtered = filtered.filter(m => m.data >= dIni);
            if (dFim) filtered = filtered.filter(m => m.data <= dFim);

            // Calcular Total
            const total = filtered.reduce((acc, curr) => acc + (curr.valor_item || 0), 0);
            totalDisplay.innerText = total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            // Renderizar Tabela
            if (filtered.length === 0) {
                tabelaArea.innerHTML = `
                    <div style="text-align: center; padding: 40px; color: #999; border: 2px dashed #eee; border-radius: 8px; background: #f9fafb;">
                        Nenhum registro encontrado para este filtro.
                    </div>
                `;
                return;
            }

            let html = `
                <div class="data-table-container">
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Máquina</th>
                            <th>Item / Serviço</th>
                            <th>Categoria</th>
                            <th>Fornecedor</th>
                            <th>Valor (R$)</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            filtered.forEach(m => {
                html += `
                    <tr>
                        <td>${m.data.split('-').reverse().join('/')}</td>
                        <td><strong style="color:var(--color-primary);">${m.maquinaNome}</strong></td>
                        <td>${m.simpleEntry ? m.peca : `${m.qtd}x ${m.peca}`}</td>
                        <td><span class="badge" style="background:#f3f4f6; color:#555;">${m.categoria}</span></td>
                        <td>${m.fornecedor}</td>
                        <td style="font-weight:600; color:#dc2626;">${m.valor_item.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    </tr>
                 `;
            });

            html += `</tbody></table></div>`;
            tabelaArea.innerHTML = html;
        };

        // Listeners
        selMaq.addEventListener('change', applyFilters);
        inpIni.addEventListener('change', applyFilters);
        inpFim.addEventListener('change', applyFilters);

        // Inicializar
        applyFilters();
    },

    // --- API PÚBLICA PARA INTEGRAÇÃO FINANCEIRA ---
    registrarAbastecimento: async function (dados) {
        // dados = { maquinaId, data, litros, valorTotal, horimetro, observacao, lancamentoId, tipoCombustivel }
        try {
            const dbPayload = {
                maquina_id: dados.maquinaId,
                data: dados.data,
                litros: dados.litros,
                horimetro: dados.horimetro,
                valor_total: dados.valorTotal,
                observacao: dados.observacao,
                lancamento_id: dados.lancamentoId || null,
                tipo_combustivel: dados.tipoCombustivel || null // NEW: Save Fuel Type
            };

            const { data, error } = await window.FazendaRP.supabase
                .from('maquinas_abastecimentos')
                .insert([dbPayload])
                .select()
                .single();

            if (error) throw error;

            console.log("Abastecimento registrado com sucesso:", data);

            // --- UPDATE MACHINE HORIMETER/KM ---
            if (dados.horimetro && dados.maquinaId) {
                const maq = this.data.frota.find(m => m.id == dados.maquinaId);
                if (maq) {
                    const updatePayload = {};

                    // Determinar se é horímetro ou km baseado no tipo da máquina
                    if (maq.tipo === 'CAMINHAO' || maq.tipo === 'CAMIONETE' || maq.tipo === 'CARRO') {
                        updatePayload.km_atual = parseFloat(dados.horimetro);
                    } else {
                        updatePayload.horimetro_atual = parseFloat(dados.horimetro);
                    }

                    const { error: updateError } = await window.FazendaRP.supabase
                        .from('frota')
                        .update(updatePayload)
                        .eq('id', dados.maquinaId);

                    if (updateError) {
                        console.warn("Erro ao atualizar horímetro da máquina:", updateError);
                    } else {
                        console.log("Horímetro/KM da máquina atualizado:", updatePayload);
                    }
                }
            }

            // --- ESTOQUE: AVISO ---
            // A baixa agora é feita AUTOMATICAMENTE pelo Trigger no Banco de Dados (trg_abastecimento_estoque).
            // Não fazemos mais via Front-end para evitar duplicidade e erros.

            /* CÓDIGO ANTIGO (DESATIVADO)
            if (window.FazendaRP.Pages.suprimentos && window.FazendaRP.Pages.suprimentos.estoque) {
                // Tenta achar o nome da maquina para o historico
                const maq = this.data.frota.find(m => m.id == dados.maquinaId);
                const maqNome = maq ? maq.nome : 'Máquina ID ' + dados.maquinaId;

                // Item Nome: Se veio do financeiro (dados.itemNome/tipoCombustivel) ou usa padrao
                const itemNome = dados.tipoCombustivel || ((maq && maq.combustiveis && maq.combustiveis[0]) ? maq.combustiveis[0] : 'Diesel S10');

                console.log(`Integrando Saída de Estoque para: ${itemNome}`);

                await window.FazendaRP.Pages.suprimentos.estoque.registrarMovimentacao({
                    itemNome: itemNome,
                    tipo: 'SAIDA',
                    quantidade: dados.litros,
                    origemTipo: 'ABASTECIMENTO',
                    origemId: null, // Avoid UUID Error for now (Store ID in Obs if needed)
                    observacao: `Abastecimento Máquina: ${maqNome} (ID Ref: ${data.id})`
                });
            }
            */

            return true;

        } catch (err) {
            console.error("Erro ao registrar abastecimento:", err);
            return false;
        }
    },

    renderAbastecimentos: function () {
        const container = document.getElementById('maquinas-content');
        if (!container) return;

        // --- RENDERIZAR ESTRUTURA DE FILTROS NA TELA ---
        const maquinasOptions = this.data.frota
            .sort((a, b) => a.nome.localeCompare(b.nome))
            .map(m => `<option value="${m.id}" ${this.filterState && this.filterState.maquina == m.id ? 'selected' : ''}>${m.nome}</option>`)
            .join('');

        // Garantir estado de filtro inicial
        if (!this.filterState) {
            this.filterState = { maquina: 'all', dataInicio: '', dataFim: '' };
        }

        const filtrosHTML = `
            <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: flex-end; background: #fff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 5px rgba(0,0,0,0.05); margin-bottom: 25px;">
                <div class="form-group" style="flex: 2; min-width: 200px;">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #555;">Filtrar por Máquina</label>
                    <select id="filtro-abs-maq" class="form-control" style="width: 100%;">
                        <option value="all">Todas as Máquinas</option>
                        ${maquinasOptions}
                    </select>
                </div>
                <div class="form-group" style="flex: 1; min-width: 130px;">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #555;">De (Data)</label>
                    <input type="date" id="filtro-abs-ini" class="form-control" style="width: 100%;" value="${this.filterState.dataInicio}">
                </div>
                <div class="form-group" style="flex: 1; min-width: 130px;">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #555;">Até (Data)</label>
                    <input type="date" id="filtro-abs-fim" class="form-control" style="width: 100%;" value="${this.filterState.dataFim}">
                </div>
                
                <!-- CARD TOTALIZADOR -->
                <div style="flex: 1; min-width: 200px; text-align: right; background: #fffbeb; padding: 10px 15px; border-radius: 8px; border: 1px solid #fef3c7;">
                    <span style="display: block; font-size: 0.85rem; color: #92400e; margin-bottom: 2px;">Total Combustível (Seleção)</span>
                    <strong id="total-abs-display" style="font-size: 1.4rem; color: #d97706;">R$ 0,00</strong>
                </div>

                 <div style="width: 100%; display:flex; justify-content:flex-end; margin-top:10px;">
                    <button id="btn-novo-abast" class="btn btn-primary" style="height: 38px; display: flex; align-items: center; gap: 8px;">
                        <i class="fas fa-plus"></i> Novo Abastecimento
                    </button>
                </div>
            </div>

            <div id="tabela-abastecimento-area"></div>
        `;

        container.innerHTML = filtrosHTML;

        // CRITICAL: Setup modal BEFORE button handler (ensures modal exists in DOM)
        this.setupAbastecimentoModal();

        // Elementos DOM
        const selMaq = document.getElementById('filtro-abs-maq');
        const inpIni = document.getElementById('filtro-abs-ini');
        const inpFim = document.getElementById('filtro-abs-fim');
        const totalDisplay = document.getElementById('total-abs-display');
        const tabelaArea = document.getElementById('tabela-abastecimento-area');
        const btnNew = document.getElementById('btn-novo-abast');

        if (btnNew) btnNew.onclick = () => {
            document.getElementById('modal-novo-abastecimento').style.display = 'flex';
        };

        // Função interna de filtragem e renderização da tabela
        const applyFilters = () => {
            let filtered = this.data.abastecimentos || [];

            // Filtro Máquina
            const maqId = selMaq ? selMaq.value : 'all';
            if (maqId !== 'all') filtered = filtered.filter(a => a.maquina_id == maqId);

            // Filtro Data
            const dIni = inpIni ? inpIni.value : '';
            const dFim = inpFim ? inpFim.value : '';
            if (dIni) filtered = filtered.filter(a => a.data >= dIni);
            if (dFim) filtered = filtered.filter(a => a.data <= dFim);

            // Sorting (Newest First)
            filtered.sort((a, b) => new Date(b.data) - new Date(a.data));

            // Calcular Total
            const total = filtered.reduce((acc, curr) => acc + (curr.valor_total || 0), 0);
            if (totalDisplay) totalDisplay.innerText = total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            // Persist State
            this.filterState.maquina = maqId;
            this.filterState.dataInicio = dIni;
            this.filterState.dataFim = dFim;

            // Renderizar Tabela
            if (filtered.length === 0) {
                tabelaArea.innerHTML = `
                    <div style="text-align: center; padding: 40px; color: #999; border: 2px dashed #eee; border-radius: 8px; background: #f9fafb;">
                        Nenhum abastecimento encontrado para este filtro.
                    </div>
                `;
                return;
            }

            let html = `
                <div class="data-table-container">
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Máquina</th>
                            <th>Combustível</th>
                            <th>Litros</th>
                            <th>Horímetro</th>
                            <th>Valor (R$)</th>
                            <th>Origem</th>
                            <th style="width: 50px;"></th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            filtered.forEach(abs => {
                const maq = this.data.frota.find(m => m.id == abs.maquina_id);
                const nomeMaq = maq ? maq.nome : 'Desconhecida';
                const dataFmt = abs.data.split('-').reverse().join('/');
                const valorFmt = (abs.valor_total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                const origem = abs.lancamento_id ? '<span class="badge" style="background:#dbeafe; color:#1e40af;">Financeiro</span>' : '<span class="badge">Manual</span>';

                // Fuel Badge Logic
                let fuelBadge = `<span style="color:#9ca3af; font-size:0.8em; display:flex; align-items:center; gap:5px;"><i class="fas fa-gas-pump"></i> Abastecimento</span>`;

                if (abs.tipo_combustivel) {
                    let color = '#e5e7eb';
                    let textCol = '#374151';
                    const typeUpper = abs.tipo_combustivel.toUpperCase();

                    if (typeUpper.includes('ETANOL')) {
                        color = '#86efac'; textCol = '#14532d'; // Green
                    } else if (typeUpper.includes('ADITIVADA')) {
                        color = '#d8b4fe'; textCol = '#581c87'; // Purple (Distinct for Aditivada)
                    } else if (typeUpper.includes('GASOLINA')) {
                        color = '#fca5a5'; textCol = '#7f1d1d'; // Red
                    } else if (typeUpper.includes('DIESEL')) {
                        if (typeUpper.includes('S500')) {
                            color = '#fdba74'; textCol = '#7c2d12'; // Orange
                        } else {
                            color = '#fcd34d'; textCol = '#713f12'; // Yellow (S10)
                        }
                    } else if (typeUpper.includes('ARLA')) {
                        color = '#93c5fd'; textCol = '#1e3a8a'; // Blue
                    }

                    fuelBadge = `<span class="badge" style="background:${color}; color:${textCol}; font-weight:600;"><i class="fas fa-gas-pump" style="margin-right:4px;"></i> ${abs.tipo_combustivel}</span>`;
                }

                html += `
                    <tr>
                        <td>${dataFmt}</td>
                        <td><strong>${nomeMaq}</strong></td>
                        <td>${fuelBadge}</td>
                        <td>${abs.litros} L</td>
                        <td>${abs.horimetro || '-'}</td>
                        <td style="font-weight:600; color:#d97706;">${valorFmt}</td>
                        <td>${origem}</td>
                        <td style="text-align:right;">
                             <button class="btn-icon delete-btn btn-del-abs" data-id="${abs.id}" title="Excluir">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                    </tr>
                `;
            });

            html += `</tbody></table></div>`;
            tabelaArea.innerHTML = html;

            // Re-attach Delete Events
            tabelaArea.querySelectorAll('.btn-del-abs').forEach(btn => {
                btn.addEventListener('click', async (e) => {
                    if (confirm("Excluir este registro de abastecimento?")) {
                        const btnEl = e.target.closest('button');
                        const id = parseInt(btnEl.dataset.id);

                        // --- NOVA LÓGICA: Sincronizar com Estoque ---
                        if (window.FazendaRP.Estoque && window.FazendaRP.Estoque.deletarMovimentacaoPorOrigem) {
                            try {
                                await window.FazendaRP.Estoque.deletarMovimentacaoPorOrigem('ABASTECIMENTO', id);
                            } catch (err) {
                                console.error("Erro ao remover do estoque:", err);
                                // Opcional: Poderíamos avisar o usuário aqui se a sincronização falhou, 
                                // mas geralmente o registro de abastecimento é o principal para o usuário.
                            }
                        }

                        const { error } = await window.FazendaRP.supabase
                            .from('maquinas_abastecimentos')
                            .delete()
                            .eq('id', id);

                        if (error) {
                            console.error(error);
                            alert("Erro ao excluir: " + error.message);
                            return;
                        }

                        this.data.abastecimentos = this.data.abastecimentos.filter(a => a.id !== id);
                        applyFilters(); // Re-render logic
                    }
                });
            });
        };

        // Listeners
        if (selMaq) selMaq.addEventListener('change', applyFilters);
        if (inpIni) inpIni.addEventListener('change', applyFilters);
        if (inpFim) inpFim.addEventListener('change', applyFilters);

        // Inicializar
        applyFilters();
    },

    setupAbastecimentoModal: function () {
        let modal = document.getElementById('modal-novo-abastecimento');
        if (!modal) {
            modal = document.createElement('div');
            modal.id = 'modal-novo-abastecimento';
            modal.style.cssText = "display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 2000; justify-content: center; align-items: center;";
            modal.innerHTML = `
                <div style="background: white; padding: 25px; border-radius: 8px; width: 100%; max-width: 450px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);">
                    <h3 style="margin-top: 0; margin-bottom: 20px;">Registrar Abastecimento</h3>
                    <form id="form-novo-abastecimento">
                        <div class="form-group">
                            <label>Data</label>
                            <input type="date" id="abs-data" class="form-control" required value="${new Date().toISOString().split('T')[0]}" style="width: 100%;">
                        </div>
                        <div class="form-group">
                            <label>Máquina</label>
                            <select id="abs-maquina" class="form-control" required style="width: 100%;">
                                <option value="">Selecione...</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Combustível</label>
                            <select id="abs-item-nome" class="form-control" required style="width: 100%; background:#f9fafb;">
                                <option value="">Selecione a Máquina...</option>
                            </select>
                        </div>
                        <div class="form-row" style="display:flex; gap: 15px;">
                            <div class="form-group" style="flex:1">
                                <label>Litros (L)</label>
                                <input type="number" id="abs-litros" step="0.01" class="form-control" required style="width: 100%;">
                            </div>
                            <div class="form-group" style="flex:1">
                                <label>Valor Total (R$) <small id="abs-unit-cost" style="color:#666; font-weight:normal;">(Custo: R$ 0,00/L)</small></label>
                                <input type="text" id="abs-valor" class="form-control money-mask" placeholder="Calculado Automaticamente" readonly style="width: 100%; background-color: #f3f4f6; cursor: not-allowed;">
                            </div>
                        </div>
                         <div class="form-group">
                            <label>Horímetro Atual (Opcional)</label>
                            <input type="number" id="abs-horimetro" step="0.1" class="form-control" style="width: 100%;">
                        </div>
                        <div class="form-group" style="background: #f0fdf4; padding: 10px; border-radius: 6px; border: 1px solid #bbf7d0; margin-top: 10px;">
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <input type="checkbox" id="abs-baixar-estoque" checked style="width: 20px; height: 20px; cursor: pointer;">
                                <div>
                                    <label for="abs-baixar-estoque" style="font-weight: bold; color: #166534; cursor: pointer; margin-bottom: 0;">Baixar do Estoque (Fazenda)</label>
                                    <div style="font-size: 12px; color: #15803d; margin-top: 2px;">Desmarque se abasteceu em posto externo (já lançado no financeiro)</div>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
                            <button type="button" id="btn-cancel-abs" class="btn" style="background: #e5e7eb;">Cancelar</button>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </form>
                </div>
                </div>
            `;
            document.body.appendChild(modal);

            // Mascara de dinheiro no input novo
            const inputVal = modal.querySelector('#abs-valor');
            if (inputVal) {
                inputVal.addEventListener('input', (e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    value = (Number(value) / 100).toLocaleString("pt-BR", { minimumFractionDigits: 2 });
                    e.target.value = value;
                });
            }

            modal.querySelector('#btn-cancel-abs').addEventListener('click', () => modal.style.display = 'none');
            modal.querySelector('#form-novo-abastecimento').addEventListener('submit', async (e) => {
                e.preventDefault();
                const btn = e.target.querySelector('button[type="submit"]');
                const oldText = btn.innerText;
                btn.innerText = "Salvando...";
                btn.disabled = true;

                const valStr = document.getElementById('abs-valor').value;
                const valTotal = parseFloat(valStr.replace(/\./g, '').replace(',', '.')) || 0;
                const itemNome = document.getElementById('abs-item-nome').value; // Get selected fuel

                const payload = {
                    maquinaId: document.getElementById('abs-maquina').value,
                    data: document.getElementById('abs-data').value,
                    litros: parseFloat(document.getElementById('abs-litros').value),
                    horimetro: document.getElementById('abs-horimetro').value || null,
                    tipoCombustivel: itemNome, // FIXED: Use correct parameter name
                    baixarEstoque: document.getElementById('abs-baixar-estoque').checked // Capture checkbox state
                };

                const success = await this.registrarAbastecimento(payload);

                if (success) {
                    window.FazendaRP.Toast.show('success', 'Sucesso', 'Abastecimento registrado!');
                    modal.style.display = 'none';
                    // CRITICAL: Reload data from database to show new entry immediately
                    await this.loadData();
                    this.renderAbastecimentos();
                } else {
                    alert("Erro ao salvar abastecimento.");
                }

                btn.disabled = false;
            });
        }


        // Helper to update Fuel Options based on machine
        const updateFuelOptions = () => {
            const maqId = select.value;
            const fuelSelect = document.getElementById('abs-item-nome');
            if (!fuelSelect) return;

            fuelSelect.innerHTML = '<option value="">Selecione...</option>';

            if (maqId) {
                const maq = this.data.frota.find(m => m.id == maqId);
                if (maq && maq.combustiveis && maq.combustiveis.length > 0) {
                    maq.combustiveis.forEach(c => {
                        const opt = document.createElement('option');
                        opt.value = c;
                        opt.innerText = c;
                        fuelSelect.appendChild(opt);
                    });
                    // Auto-select first
                    fuelSelect.value = maq.combustiveis[0];
                } else {
                    // Default fallback
                    const opt = document.createElement('option');
                    opt.value = "Diesel S10";
                    opt.innerText = "Diesel S10 (Padrão)";
                    fuelSelect.appendChild(opt);
                    fuelSelect.value = "Diesel S10";
                }
            }
        };

        // Logic to fetch Average Cost and Calculate Total
        const updateCost = async () => {
            const fuelName = document.getElementById('abs-item-nome').value;
            const litros = parseFloat(document.getElementById('abs-litros').value) || 0;
            const unitCostLabel = document.getElementById('abs-unit-cost');
            const totalInput = document.getElementById('abs-valor');

            if (!fuelName) return;

            // Fetch Cost from Stock
            // Simple Cache to avoid spamming DB
            try {
                const { data, error } = await window.FazendaRP.supabase
                    .from('suprimentos_estoque')
                    .select('custo_medio')
                    .ilike('item_nome', fuelName) // Case insensitive match
                    .maybeSingle();

                const custo = (data && data.custo_medio) ? data.custo_medio : 0;

                // Update Label
                if (unitCostLabel) unitCostLabel.innerText = `(Custo: ${custo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}/L)`;

                // Calculate Total
                const total = litros * custo;
                if (totalInput) {
                    totalInput.value = total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    totalInput.dataset.rawValue = total;
                }

            } catch (err) {
                console.error("Error fetching cost:", err);
            }
        };

        const fuelSelect = document.getElementById('abs-item-nome');
        const litersInput = document.getElementById('abs-litros');

        if (fuelSelect) fuelSelect.addEventListener('change', updateCost);
        if (litersInput) litersInput.addEventListener('input', updateCost);

        // Trigger update if options change via machine select
        // We need to re-attach the listener or call it when machine changes
        // The machine select listener is defined below. We can leave this definition here.


        const select = document.getElementById('abs-maquina');
        if (select) {
            select.addEventListener('change', async () => {
                updateFuelOptions();
                await updateCost(); // Recalc when machine changes (and thus fuel defaults)
            });

            const currentVal = select.value;
            let options = '<option value="">Selecione...</option>';
            if (this.data.frota && this.data.frota.length > 0) {
                options += this.data.frota.map(m => `<option value="${m.id}">${m.nome}</option>`).join('');
            }
            select.innerHTML = options;
            if (currentVal) {
                select.value = currentVal;
                updateFuelOptions();
            }
        }
    },

    registrarAbastecimento: async function (payload) {
        try {
            // 1. Salvar no Banco de Dados (Abastecimento)
            const { data, error } = await window.FazendaRP.supabase
                .from('maquinas_abastecimentos')
                .insert([{
                    maquina_id: payload.maquinaId,
                    data: payload.data,
                    litros: payload.litros,
                    horimetro: payload.horimetro,
                    valor_total: payload.valorTotal,
                    tipo_combustivel: payload.tipoCombustivel,
                    lancamento_id: payload.lancamentoId || null // Link com Financeiro
                }])
                .select();

            if (error) throw error;

            console.log("Abastecimento salvo com sucesso:", data);
            const abastecimentoId = data[0].id;

            // 2. Integrar com Estoque (Dar Baixa / SAÍDA)
            // Apenas se a opção "Baixar do Estoque" estiver marcada (padrão true)
            if (payload.baixarEstoque !== false) {
                // Verifica se a API de Estoque está disponível
                if (window.FazendaRP.Estoque && window.FazendaRP.Estoque.registrarMovimentacao) {
                    console.log("Integrando com Estoque (SAIDA)...");
                    try {
                        await window.FazendaRP.Estoque.registrarMovimentacao({
                            itemNome: payload.tipoCombustivel, // Ex: 'Diesel S500', 'Etanol'
                            tipo: 'SAIDA',
                            quantidade: payload.litros,
                            origemTipo: 'ABASTECIMENTO', // Tag para rastreio
                            origemId: abastecimentoId,   // Link com o registro de abastecimento
                            dataOperacao: payload.data,  // Data do abastecimento
                            observacao: `Abastecimento Máquina ID: ${payload.maquinaId}`,
                            unidade: 'L' // Combustível é sempre Litro
                        });
                        console.log("Baixa no estoque realizada com sucesso.");
                    } catch (stockErr) {
                        console.error("Erro ao dar baixa no estoque:", stockErr);
                        alert("Aviso: O abastecimento foi salvo, mas houve erro ao atualizar o estoque: " + stockErr.message);
                    }
                } else {
                    console.warn("API de Estoque não encontrada. Baixa não realizada.");
                }
            } else {
                console.log("Opção 'Baixar do Estoque' desmarcada. Apenas registro de estatísticas.");
            }

            return true;

        } catch (err) {
            console.error("Erro ao registrar abastecimento:", err);
            return false;
        }
    },




    // --- MODAL NOVA MÁQUINA (Conectado ao Supabase - COMPLETO) ---
    setupModalNovaMaquina: function () {
        if (document.getElementById('modal-nova-maquina')) return;

        const modal = document.createElement('div');
        modal.id = 'modal-nova-maquina';
        modal.style.cssText = "display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 2000; justify-content: center; align-items: center;";

        modal.innerHTML = `
            <div style="background: white; padding: 25px; border-radius: 8px; width: 100%; max-width: 600px; max-height: 90vh; overflow-y: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.2);">
                <h3 id="titulo-modal-maq" style="margin-top: 0; color: var(--color-primary); border-bottom: 2px solid #f3f4f6; padding-bottom: 15px;">Nova Máquina / Veículo</h3>
                
                <form id="form-nova-maquina" style="display: grid; gap: 15px;">
                    <!-- Linha 1: Nome, Tipo e SITUAÇÃO -->
                    <div style="display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 15px;">
                        <div class="form-group">
                            <label style="font-weight: 500; font-size: 0.9rem;">Nome / Identificação *</label>
                            <input type="text" id="maq-nome" class="form-control" placeholder="Ex: Trator Valtra A950" required style="width:100%">
                        </div>
                        <div class="form-group">
                            <label style="font-weight: 500; font-size: 0.9rem;">Tipo *</label>
                            <select id="maq-tipo" class="form-control" style="width:100%" required>
                                <option value="TRATOR">Trator</option>
                                <option value="CAMINHAO">Caminhão</option>
                                <option value="CAMIONETE">Caminhonete</option>
                                <option value="CARRO">Carro</option>
                                <option value="COLHEITADEIRA">Colheitadeira</option>
                                <option value="IMPLEMENTO">Implemento</option>
                                <option value="OUTRO">Outro</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label style="font-weight: 500; font-size: 0.9rem;">Situação</label>
                            <select id="maq-status" class="form-control" style="width:100%">
                                <option value="ativo">Ativo</option>
                                <option value="vendido">Vendido</option>
                                <option value="inativo">Inativo</option>
                            </select>
                        </div>
                    </div>

                    <!-- Linha 2: Modelo, Ano e Placa -->
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 15px;">
                        <div class="form-group">
                            <label style="font-weight: 500; font-size: 0.9rem;">Modelo</label>
                            <input type="text" id="maq-modelo" class="form-control" style="width:100%">
                        </div>
                        <div class="form-group">
                            <label style="font-weight: 500; font-size: 0.9rem;">Ano Fab.</label>
                            <input type="number" id="maq-ano" class="form-control" placeholder="Ex: 2022" style="width:100%">
                        </div>
                        <div class="form-group">
                            <label style="font-weight: 500; font-size: 0.9rem;">Placa (Op.)</label>
                            <input type="text" id="maq-placa" class="form-control" style="width:100%">
                        </div>
                    </div>

                    <!-- Linha 3: Aquisição (Data e Valor) -->
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; background: #f9fafb; padding: 10px; border-radius: 6px;">
                        <div class="form-group">
                            <label style="font-weight: 500; font-size: 0.9rem;">Ano de Aquisição</label> 
                            <input type="number" id="maq-ano-aq" class="form-control" placeholder="Ex: 2024" style="width:100%"> 
                        </div>
                        <div class="form-group">
                            <label style="font-weight: 500; font-size: 0.9rem;">Valor de Compra</label>
                            <input type="text" id="maq-valor" class="form-control" placeholder="R$ 0,00" style="width:100%">
                        </div>
                    </div>

                    <!-- Linha 4: Medidor (Horímetro ou KM) -->
                    <div class="form-group" id="container-medidor">
                        <label style="font-weight: 500; font-size: 0.9rem;" id="label-medidor">Horímetro Inicial (Horas)</label>
                        <input type="text" id="maq-medidor" class="form-control" placeholder="0" style="width:100%">
                        <small style="color: #666; font-size: 0.8rem;">Informe o valor que está no painel hoje.</small>
                    </div>

                    <!-- Linha 5: Combustíveis Permitidos -->
                    <div class="form-group" style="background:#f0fdf4; padding:10px; border-radius:6px; border:1px solid #bbf7d0;">
                        <label style="font-weight: 500; font-size: 0.9rem; display:block; margin-bottom:8px; color:#166534;">Combustíveis / Abastecimento Permitido</label>
                        <div style="display:flex; flex-wrap:wrap; gap:15px;" id="maq-combustiveis-container">
                             <label style="display:flex; align-items:center; gap:5px; font-size:0.9em; cursor:pointer;">
                                 <input type="checkbox" value="Diesel S10"> Diesel S10
                             </label>
                             <label style="display:flex; align-items:center; gap:5px; font-size:0.9em; cursor:pointer;">
                                 <input type="checkbox" value="Diesel S500"> Diesel S500
                             </label>
                             <label style="display:flex; align-items:center; gap:5px; font-size:0.9em; cursor:pointer;">
                                 <input type="checkbox" value="Gasolina"> Gasolina
                             </label>
                             <label style="display:flex; align-items:center; gap:5px; font-size:0.9em; cursor:pointer;">
                                 <input type="checkbox" value="Etanol"> Etanol
                             </label>
                             <label style="display:flex; align-items:center; gap:5px; font-size:0.9em; cursor:pointer;">
                                 <input type="checkbox" value="Arla 32"> Arla 32
                             </label>
                        </div>
                    </div>
                    
                    <!-- Botões -->
                    <div style="margin-top:15px; display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #eee; padding-top: 15px;">
                        <!-- Botão Excluir (Esquerda) -->
                        <button type="button" id="btn-delete-maq" class="btn" style="background: #fee2e2; color: #b91c1c; border: 1px solid #fca5a5; display: none;">Excluir Máquina</button>
                        
                        <!-- Botões Ação (Direita) -->
                        <div style="display: flex; gap: 10px;">
                            <button type="button" id="btn-cancel-maq" class="btn" style="background: #e5e7eb; color: #333;">Cancelar</button>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        `;
        document.body.appendChild(modal);

        const btnCancel = document.getElementById('btn-cancel-maq');
        if (btnCancel) btnCancel.onclick = () => modal.style.display = 'none';

        const tipoSelect = document.getElementById('maq-tipo');
        const medidorLabel = document.getElementById('label-medidor');
        const medidorContainer = document.getElementById('container-medidor');

        // Máscara de Moeda (Melhorada)
        const inputValor = document.getElementById('maq-valor');
        inputValor.addEventListener('input', (e) => {
            let value = e.target.value.replace(/\D/g, "");
            const floatVal = Number(value) / 100;
            e.target.value = floatVal.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL"
            });
        });

        const inputMedidor = document.getElementById('maq-medidor');
        inputMedidor.addEventListener('input', (e) => {
            let val = e.target.value.replace(/\D/g, ""); // Remove tudo que não é dígito
            const tipo = tipoSelect.value;

            if (tipo === 'CAMINHAO' || tipo === 'CAMIONETE' || tipo === 'CARRO') {
                // MÁSCARA KM (Milhar): 110.000
                if (val === '') { e.target.value = ''; return; }
                e.target.value = parseInt(val).toLocaleString('pt-BR');
            } else {
                // MÁSCARA HORÍMETRO (Decimal): 1234,5
                // Assumindo que o usuário digita centésimos se quiser, ou apenas inteiros
                // Mas geralmente horímetro tem uma casa decimal. Vamos fazer formatador livre
                // Permitir vírgula. Melhor deixar livre e só validar se é número?
                // O usuário pediu especificamente "mascara de horas". 
                // Vamos tentar simular um input monetário simples de 1 decimal
                if (val === '') { e.target.value = ''; return; }
                const floatVal = parseInt(val) / 10; // Uma casa decimal
                e.target.value = floatVal.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
            }
        });

        tipoSelect.addEventListener('change', (e) => {
            const val = e.target.value;
            // Limpa o valor ao trocar de tipo pra evitar confusão de formatos
            inputMedidor.value = '';

            // Lógica para esconder N/A se for Implemento
            if (val === 'IMPLEMENTO') {
                medidorContainer.style.display = 'none'; // Some completamente
            } else {
                medidorContainer.style.display = 'block'; // Aparece
                if (val === 'CAMINHAO' || val === 'CAMIONETE' || val === 'CARRO') {
                    medidorLabel.innerText = "Quilometragem Inicial (KM)";
                    inputMedidor.placeholder = "Ex: 110.000";
                } else {
                    medidorLabel.innerText = "Horímetro Inicial (Horas)";
                    inputMedidor.placeholder = "Ex: 1.234,5";
                }
            }
        });

        document.getElementById('form-nova-maquina').onsubmit = async (e) => {
            e.preventDefault();
            const btn = e.target.querySelector('button[type="submit"]');
            const oldText = btn.innerText;
            btn.innerText = "Salvando...";
            btn.disabled = true;

            const idHidden = document.getElementById('maq-id-hidden');
            const idToEdit = idHidden && idHidden.value ? idHidden.value : null;

            const tipo = document.getElementById('maq-tipo').value;
            const status = document.getElementById('maq-status').value; // PEGA O STATUS

            // TRATAMENTO DO MEDIDOR (Remove formatação)
            const medidorStr = document.getElementById('maq-medidor').value;
            // Remove pontos de milhar e troca virgula decimal por ponto
            // Ex KM: 110.000 -> 110000
            // Ex HR: 1.234,5 -> 1234.5
            const medidorClean = medidorStr.replace(/\./g, '').replace(',', '.').trim();
            let medidor = parseFloat(medidorClean) || 0;

            if (tipo === 'IMPLEMENTO') medidor = 0;

            let km = 0;
            let horas = 0;
            if (tipo === 'CAMINHAO' || tipo === 'CAMIONETE' || tipo === 'CARRO') km = medidor;
            else if (tipo !== 'IMPLEMENTO') horas = medidor;

            // TRATAMENTO DO VALOR EM REAIS
            const valorString = document.getElementById('maq-valor').value;
            const cleanString = valorString.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
            const valorFloat = parseFloat(cleanString) || 0;

            // TRATAMENTO DA DATA
            const anoInput = document.getElementById('maq-ano-aq').value;
            const dataAqSql = anoInput ? `${anoInput}-01-01` : null;

            // TRATAMENTO COMBUSTIVEIS
            const combustiveis = Array.from(document.querySelectorAll('#maq-combustiveis-container input:checked')).map(c => c.value);

            const payload = {
                nome: document.getElementById('maq-nome').value,
                tipo: tipo,
                status: status, // ENVIA O STATUS
                modelo: document.getElementById('maq-modelo').value,
                ano: document.getElementById('maq-ano').value,
                placa: document.getElementById('maq-placa').value,
                data_aquisicao: dataAqSql,
                valor_aquisicao: valorFloat,
                combustiveis: combustiveis
            };

            // Se for novo, inicializa métricas e GERA ID
            if (!idToEdit) {
                payload.id = Date.now();
                payload.km_inicial = km;
                payload.km_atual = km;
                payload.horimetro_inicial = horas;
                payload.horimetro_atual = horas;
            } else {
                // Se edição
                payload.km_atual = km;
                payload.horimetro_atual = horas;
            }

            try {
                let error;
                if (idToEdit) {
                    const { error: err } = await window.FazendaRP.supabase
                        .from('frota')
                        .update(payload)
                        .eq('id', idToEdit);
                    error = err;
                } else {
                    const { error: err } = await window.FazendaRP.supabase
                        .from('frota')
                        .insert([payload]);
                    error = err;
                }

                if (error) throw error;

                alert('Salvo com sucesso!');
                this.loadData();
                modal.style.display = 'none';
            } catch (err) {
                console.error("Erro ao salvar:", err);
                alert("Erro ao salvar: " + err.message);
            } finally {
                btn.innerText = oldText;
                btn.disabled = false;
            }
        };
    },

    cleanDuplicates: async function () {
        if (!confirm('ATENÇÃO: Isso irá apagar registros duplicados (mesma data, máquina, litros e valor) permanetemente do banco de dados. Tem certeza?')) return;

        try {
            // 1. Fetch All
            const { data, error } = await window.FazendaRP.supabase
                .from('maquinas_abastecimentos')
                .select('*');

            if (error) throw error;

            // 2. Group
            const groups = {};
            data.forEach(item => {
                const key = `${item.data}|${item.maquina_id}|${item.litros}|${item.valor_total}`;
                if (!groups[key]) groups[key] = [];
                groups[key].push(item);
            });

            // 3. Identify Dupes
            const idsToDelete = [];
            let dupesCount = 0;

            for (const key in groups) {
                const items = groups[key];
                if (items.length > 1) {
                    // Keep the one with lowest ID (oldest) or highest? 
                    // Usually oldest is original.
                    // Sort by ID
                    items.sort((a, b) => a.id - b.id);
                    // Remove first (keep), delete rest
                    const toDelete = items.slice(1);
                    toDelete.forEach(x => idsToDelete.push(x.id));
                    dupesCount += toDelete.length;
                }
            }

            if (idsToDelete.length === 0) {
                alert('Nenhuma duplicata encontrada.');
                return;
            }

            // 4. Delete
            const { error: errDel } = await window.FazendaRP.supabase
                .from('maquinas_abastecimentos')
                .delete()
                .in('id', idsToDelete);

            if (errDel) throw errDel;

            alert(`Sucesso! ${dupesCount} registros duplicados foram removidos.`);
            window.location.reload();

        } catch (err) {
            console.error("Erro na limpeza:", err);
            alert("Erro ao limpar: " + err.message);
        }
    }
    ,

    // --- DASHBOARD LOGIC START ---

    ensureManutencoesLoaded: async function () {
        if (!this.cachedManutencoes) {
            console.log("Preloading Manutencoes for Dashboard...");
            try {
                const { data: lancamentos, error } = await window.FazendaRP.supabase
                    .from('financeiro_lancamentos')
                    .select(`*, parceiros (nome)`)
                    .eq('tipo', 'Despesa')
                    .neq('status', 'Cancelado')
                    .order('data_emissao', { ascending: false })
                    .limit(2000);

                if (error) throw error;

                const manutencoes = [];
                lancamentos.forEach(l => {
                    const dataL = l.data_emissao || (l.detalhes && l.detalhes.data_emissao) || l.data_vencimento;

                    if (l.detalhes && l.detalhes.itens && Array.isArray(l.detalhes.itens)) {
                        l.detalhes.itens.forEach(item => {
                            if (item.maquina_id) {
                                const maq = this.data.frota.find(m => m.id == item.maquina_id);
                                manutencoes.push({
                                    id: l.id,
                                    data: dataL,
                                    maquinaId: item.maquina_id,
                                    maquinaNome: maq ? maq.nome : 'Desconhecida',
                                    peca: item.nome,
                                    qtd: item.qtd,
                                    valor_item: item.total,
                                    categoria: item.categoria || l.detalhes.categoria || 'Geral'
                                });
                            }
                        });
                    }
                    if (l.detalhes && l.detalhes.custo_maquinas && Array.isArray(l.detalhes.custo_maquinas)) {
                        l.detalhes.custo_maquinas.forEach(c => {
                            const maq = this.data.frota.find(m => m.id == c.maquina_id);
                            manutencoes.push({
                                id: l.id,
                                data: dataL,
                                maquinaId: c.maquina_id,
                                maquinaNome: maq ? maq.nome : 'Desconhecida',
                                peca: (l.descricao || 'Despesa Geral'),
                                qtd: 1,
                                valor_item: c.valor,
                                categoria: l.detalhes.categoria || l.categoria || 'Geral'
                            });
                        });
                    }
                });
                this.cachedManutencoes = manutencoes;
            } catch (err) {
                console.error("Error preloading manutencoes:", err);
            }
        }
    },

    currentDashMachineFilter: 'all',
    currentDashMonth: new Date().toISOString().slice(0, 7), // YYYY-MM

    renderDashboard: function () {
        const container = document.getElementById('maquinas-content');
        if (!container) return;

        // Structure
        const maquinasOpts = this.data.frota.map(m => `<option value="${m.id}" ${this.currentDashMachineFilter == m.id ? 'selected' : ''}>${m.nome}</option>`).join('');

        container.innerHTML = `
            <!-- Filter -->
            <div style="display:flex; justify-content:flex-end; margin-bottom:20px; align-items:center; flex-wrap:wrap; gap:15px;">
                 
                 <div style="display:flex; flex-direction:column;">
                    <label style="font-weight: 600; color: #4b5563; font-size: 0.8rem; margin-bottom:4px;">Mês de Referência:</label>
                    <input type="month" id="dash-filter-month" class="form-control" style="width: 180px;" value="${this.currentDashMonth}">
                 </div>

                 <div style="display:flex; flex-direction:column;">
                    <label style="font-weight: 600; color: #4b5563; font-size: 0.8rem; margin-bottom:4px;">Filtrar Máquina:</label>
                    <select id="dash-filter-maq" class="form-control" style="width: 250px;">
                        <option value="all">Todas as Máquinas</option>
                        ${maquinasOpts}
                    </select>
                 </div>
            </div>

            <!-- KPI Cards -->
            <div class="dashboard-grid" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px; margin-bottom: 30px;">
                
                <!-- 1. Last Activity -->
                <div class="metric-card" style="background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%); color: white; border-radius: 12px; padding: 20px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); position:relative; overflow:hidden;">
                     <i class="fas fa-history" style="position: absolute; right: -10px; bottom: -10px; font-size: 5rem; opacity: 0.2; transform: rotate(-15deg);"></i>
                     <div class="metric-title" style="color: #e0e7ff; font-size: 0.8rem; text-transform:uppercase;">Última Atividade</div>
                     <div class="metric-value" id="kpi-last-act" style="font-size: 1.3rem; font-weight:700;">-</div>
                     <div class="metric-sub" id="kpi-last-desc" style="color: #fff; font-size: 0.85rem; margin-top:5px;">
                         Sem dados
                     </div>
                </div>

                <!-- 2. Manutencao -->
                <div class="metric-card" style="background: white; border-radius: 12px; padding: 20px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); position:relative; overflow:hidden;">
                     <i class="fas fa-tools" style="position: absolute; right: -10px; bottom: -10px; font-size: 5rem; opacity: 0.05; transform: rotate(-15deg); color:red;"></i>
                     <div class="metric-title" style="color: #6b7280; font-size: 0.8rem; text-transform:uppercase;">Manutenção (Mês)</div>
                     <div class="metric-value" id="kpi-manut" style="font-size: 1.8rem; font-weight:700; color:#1f2937;">R$ 0,00</div>
                     <div class="metric-sub" style="color: #dc2626; font-size:0.8rem;"><i class="fas fa-info-circle"></i> Peças e Serviços</div>
                </div>

                 <!-- 3. Combustivel -->
                <div class="metric-card" style="background: white; border-radius: 12px; padding: 20px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); position:relative; overflow:hidden;">
                     <i class="fas fa-gas-pump" style="position: absolute; right: -10px; bottom: -10px; font-size: 5rem; opacity: 0.05; transform: rotate(-15deg); color:orange;"></i>
                     <div class="metric-title" style="color: #6b7280; font-size: 0.8rem; text-transform:uppercase;">Combustível (Mês)</div>
                     <div class="metric-value" id="kpi-fuel" style="font-size: 1.8rem; font-weight:700; color:#1f2937;">R$ 0,00</div>
                     <div class="metric-sub" style="color: #ea580c; font-size:0.8rem;"><i class="fas fa-info-circle"></i> Diesel e Outros</div>
                </div>

                 <!-- 4. Total Cost -->
                <div class="metric-card" style="background: linear-gradient(135deg, #1f2937 0%, #111827 100%); color: white; border-radius: 12px; padding: 20px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); position:relative; overflow:hidden;">
                     <i class="fas fa-wallet" style="position: absolute; right: -10px; bottom: -10px; font-size: 5rem; opacity: 0.2; transform: rotate(-15deg);"></i>
                     <div class="metric-title" style="color: #e5e7eb; font-size: 0.8rem; text-transform:uppercase;">Custo Total (Mês)</div>
                     <div class="metric-value" id="kpi-total" style="font-size: 1.8rem; font-weight:700;">R$ 0,00</div>
                     <div class="metric-sub" style="color: #9ca3af; font-size:0.8rem;">Soma Geral</div>
                </div>

            </div>

            <!-- Charts Container -->
            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(400px, 1fr)); gap: 20px; margin-bottom: 30px;">
                <div style="background: white; padding: 20px; border-radius: 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                    <h3 style="margin-bottom: 15px; font-size: 1rem; font-weight: 600;">Evolução de Custos (6 Meses)</h3>
                    <div style="height: 250px;"><canvas id="chart-costs"></canvas></div>
                </div>
                 <div style="background: white; padding: 20px; border-radius: 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                    <h3 style="margin-bottom: 15px; font-size: 1rem; font-weight: 600;">Distribuição de Despesas</h3>
                     <div style="height: 250px; display:flex; justify-content:center;"><canvas id="chart-pie"></canvas></div>
                </div>
            </div>

            <!-- Detailed Table -->
            <div style="background: white; padding: 20px; border-radius: 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                 <h3 id="dash-table-title" style="margin-bottom: 15px; font-size: 1rem; font-weight: 600;">Detalhamento por Máquina (Mês Atual)</h3>
                 <div style="overflow-x:auto;">
                     <table class="data-table" style="width:100%; border-collapse:collapse;">
                        <thead>
                            <tr style="border-bottom: 2px solid #f3f4f6; text-align:left; color:#6b7280; font-size:0.85rem; text-transform:uppercase;">
                                <th style="padding:12px;">Máquina</th>
                                <th style="padding:12px; text-align:right;">Manutenção</th>
                                <th style="padding:12px; text-align:right;">Combustível</th>
                                <th style="padding:12px; text-align:right;">Total</th>
                            </tr>
                        </thead>
                        <tbody id="dash-table-body"></tbody>
                     </table>
                 </div>
            </div>
        `;

        // Filter Logic
        const filterSel = document.getElementById('dash-filter-maq');
        filterSel.value = this.currentDashMachineFilter;
        filterSel.addEventListener('change', () => {
            this.currentDashMachineFilter = filterSel.value;
            this.updateDashboardMetrics();
        });

        const filterMonth = document.getElementById('dash-filter-month');
        filterMonth.addEventListener('change', () => {
            this.currentDashMonth = filterMonth.value;
            this.updateDashboardMetrics();
        });

        // Run Calcs
        this.updateDashboardMetrics();
    },

    updateDashboardMetrics: function () {
        // Data Sources
        const filterId = this.currentDashMachineFilter;
        const allManut = this.cachedManutencoes || [];
        const allFuel = this.data.abastecimentos || [];
        const cars = this.data.frota || [];

        // Date Helpers
        const [selYear, selMonth] = this.currentDashMonth.split('-').map(Number);

        // Update Screen Title
        const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
        const titleEl = document.getElementById('dash-table-title');
        if (titleEl) titleEl.innerText = `Detalhamento por Máquina (${monthNames[selMonth - 1]} ${selYear})`;

        // 1. FILTERING DATA FOR KPIs (Selected Month)
        // ----------------------------------------------------------------
        let kpiManut = 0;
        let kpiFuel = 0;
        let lastActivity = null;

        const isSelectedMonth = (dateStr) => {
            if (!dateStr) return false;
            const d = new Date(dateStr);
            // new Date() uses local timezone, input type="date" string is YYYY-MM-DD. 
            // Be careful with timezone offset. Safest is to slice string if format is YYYY-MM-DD.
            // Assumption: dateStr is YYYY-MM-DD
            const [y, m, dNum] = dateStr.split('-').map(Number);
            return m === selMonth && y === selYear;
        };

        // Filter Manut
        const filteredManut = allManut.filter(m => {
            const matchesMachine = (filterId === 'all') || (m.maquinaId == filterId);
            return matchesMachine;
        });

        // Calc KPI Manut (Month)
        filteredManut.forEach(m => {
            if (isSelectedMonth(m.data)) kpiManut += (m.valor_item || 0);
        });

        // Filter Fuel
        const filteredFuel = allFuel.filter(f => {
            const mid = f.maquina_id || f.maquinaId;
            const matchesMachine = (filterId === 'all') || (mid == filterId);
            return matchesMachine;
        });

        // Calc KPI Fuel (Month)
        filteredFuel.forEach(f => {
            if (isSelectedMonth(f.data)) kpiFuel += (f.valor_total || 0);
        });

        // 2. LAST ACTIVITY
        // ----------------------------------------------------------------
        // Combine activities
        const activities = [];
        filteredManut.forEach(m => activities.push({ type: 'Manutenção', date: m.data, desc: m.peca, maq: m.maquinaNome }));
        filteredFuel.forEach(f => {
            // Find machine name for fuel
            const mName = cars.find(c => c.id == (f.maquina_id || f.maquinaId))?.nome || 'Desconhecida';
            activities.push({ type: 'Abastecimento', date: f.data, desc: `${f.litros}L de ${f.tipo_combustivel || 'Combustível'}`, maq: mName });
        });

        activities.sort((a, b) => new Date(b.date) - new Date(a.date));
        const lastAct = activities[0];

        // 3. RENDER KPIs
        // ----------------------------------------------------------------
        document.getElementById('kpi-manut').innerText = kpiManut.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        document.getElementById('kpi-fuel').innerText = kpiFuel.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        document.getElementById('kpi-total').innerText = (kpiManut + kpiFuel).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        if (lastAct) {
            document.getElementById('kpi-last-act').innerText = lastAct.type;
            const when = new Date(lastAct.date).toLocaleDateString('pt-BR');
            document.getElementById('kpi-last-desc').innerHTML = `
                <div style="font-weight:600; font-size:1rem; margin-bottom:2px;">${lastAct.maq}</div>
                <div style="opacity:0.8; font-size:0.85rem;"><i class="far fa-calendar"></i> ${when} - ${lastAct.desc}</div>
            `;
        } else {
            document.getElementById('kpi-last-act').innerText = "-";
            document.getElementById('kpi-last-desc').innerText = "Sem atividades recentes";
        }

        // 4. CHART: COST EVOLUTION (Last 6 months)
        // ----------------------------------------------------------------
        this.renderCostChart(filteredManut, filteredFuel);
        this.renderPieChart(filteredManut, filteredFuel, isSelectedMonth);

        // 5. TABLE: DETAILED (Selected Month)
        // ----------------------------------------------------------------
        this.renderDetailedTable(allManut, allFuel, cars, isSelectedMonth, filterId);
    },

    renderDetailedTable: function (manut, fuel, cars, isMonthFn, filterId) {
        const tbody = document.getElementById('dash-table-body');
        if (!tbody) return;
        tbody.innerHTML = '';

        // Aggregate by Machine
        const agg = {}; // { maqId: { name: '', manut: 0, fuel: 0 } }

        let targetCars = cars;
        if (filterId !== 'all') targetCars = cars.filter(c => c.id == filterId);

        targetCars.forEach(c => {
            agg[c.id] = { name: c.nome, manut: 0, fuel: 0, type: c.tipo };
        });

        // Sum Manut (Month)
        manut.forEach(m => {
            if (isMonthFn(m.data) && agg[m.maquinaId]) agg[m.maquinaId].manut += (m.valor_item || 0);
        });

        // Sum Fuel (Month)
        fuel.forEach(f => {
            const mid = f.maquina_id || f.maquinaId;
            if (isMonthFn(f.data) && agg[mid]) agg[mid].fuel += (f.valor_total || 0);
        });

        // Render Rows
        Object.values(agg).forEach(item => {
            const total = item.manut + item.fuel;
            // Only show if > 0 or if specific filter active
            if (total > 0 || filterId !== 'all') {
                const tr = document.createElement('tr');
                tr.style.borderBottom = '1px solid #f3f4f6';
                tr.innerHTML = `
                    <td style="padding:12px; color:#1f2937;"><strong>${item.name}</strong> <span style="font-size:0.75rem; color:#6b7280; background:#f3f4f6; padding:2px 4px; border-radius:4px;">${item.type}</span></td>
                    <td style="padding:12px; text-align:right; color:#dc2626;">${item.manut.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                    <td style="padding:12px; text-align:right; color:#ea580c;">${item.fuel.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                    <td style="padding:12px; text-align:right; font-weight:700;">${total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                `;
                tbody.appendChild(tr);
            }
        });
    },

    chartInstanceCosts: null,
    chartInstancePie: null,

    renderCostChart: function (manutList, fuelList) {
        const ctx = document.getElementById('chart-costs');
        if (!ctx) return;
        const canvas = ctx.getContext('2d');

        // Prepare Data: Last 6 months labels
        const labels = [];
        const dataManut = new Array(6).fill(0);
        const dataFuel = new Array(6).fill(0);

        const today = new Date();
        for (let i = 5; i >= 0; i--) {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            labels.push(d.toLocaleString('pt-BR', { month: 'short' })); // Jul, Ago..

            const mIdx = d.getMonth();
            const yIdx = d.getFullYear();

            // Sum logic
            manutList.forEach(m => {
                const md = new Date(m.data);
                if (md.getMonth() === mIdx && md.getFullYear() === yIdx) dataManut[i] += (m.valor_item || 0);
            });
            fuelList.forEach(f => {
                const fd = new Date(f.data);
                if (fd.getMonth() === mIdx && fd.getFullYear() === yIdx) dataFuel[i] += (f.valor_total || 0);
            });
        }

        if (this.chartInstanceCosts) this.chartInstanceCosts.destroy();

        if (typeof Chart !== 'undefined') {
            this.chartInstanceCosts = new Chart(canvas, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [
                        { label: 'Manutenção', data: dataManut, backgroundColor: 'rgba(239, 68, 68, 0.7)' },
                        { label: 'Combustível', data: dataFuel, backgroundColor: 'rgba(234, 179, 8, 0.7)' }
                    ]
                },
                options: { responsive: true, maintainAspectRatio: false, scales: { y: { beginAtZero: true }, x: { grid: { display: false } } } }
            });
        }
    },

    renderPieChart: function (manutList, fuelList, isMonthFn) {
        const ctx = document.getElementById('chart-pie');
        if (!ctx) return;

        let totalFuel = 0;
        let totalPecas = 0;
        let totalServ = 0;

        fuelList.forEach(f => { if (isMonthFn(f.data)) totalFuel += (f.valor_total || 0); });

        manutList.forEach(m => {
            if (isMonthFn(m.data)) {
                const cat = (m.categoria || '').toLowerCase();
                if (cat.includes('servi') || cat.includes('mão de obra')) totalServ += (m.valor_item || 0);
                else totalPecas += (m.valor_item || 0);
            }
        });

        if (this.chartInstancePie) this.chartInstancePie.destroy();

        if (typeof Chart !== 'undefined') {
            this.chartInstancePie = new Chart(ctx.getContext('2d'), {
                type: 'doughnut',
                data: {
                    labels: ['Combustível', 'Peças', 'Serviços'],
                    datasets: [{
                        data: [totalFuel, totalPecas, totalServ],
                        backgroundColor: ['#eab308', '#ef4444', '#3b82f6'],
                        borderWidth: 0
                    }]
                },
                options: { responsive: true, maintainAspectRatio: false, cutout: '70%', plugins: { legend: { position: 'bottom' } } }
            });
        }
    },
    // --- DASHBOARD LOGIC END ---

};
